import {LEAGUES} from '../constants/leagues';

/**
 * ЕЖЕДНЕВНЫЕ КРИСТАЛЛЫ ЗА РЕЙТИНГ.
 *
 * В момент смены игровых суток (граница — та же, что у награды за вход и
 * двойной награды за первый рейтинговый матч дня, см. getGameDayKey) сервер
 * проходит по игрокам и:
 *   - у игроков золотой лиги и выше снимает RATING_DAILY_PENALTY рейтинга и
 *     начисляет кристаллы за лигу;
 *   - у первых трёх мест Зала славы начисляет кристаллы за место — независимо
 *     от лиги.
 * Боты не участвуют ни в начислении, ни в списании.
 *
 * Конфиг общий для клиента и сервера: сервер начисляет, клиент теми же
 * числами объясняет игроку, за что именно.
 */

// Сколько рейтинга снимается за день у игроков золотой лиги и выше
export const RATING_DAILY_PENALTY = 10;

// Кристаллы за пребывание в лиге (бронза и серебро ничего не дают)
export const LEAGUE_DAILY_CRYSTALS = {
  [LEAGUES.GOLD]: 10,
  [LEAGUES.DIAMOND]: 20,
  [LEAGUES.RUBY]: 50,
  [LEAGUES.GOD]: 100,
};

// Кристаллы за место в Зале славы: индекс = место − 1
export const GLORY_HALL_DAILY_CRYSTALS = [200, 100, 50];

export const GLORY_HALL_REWARDED_PLACES = GLORY_HALL_DAILY_CRYSTALS.length;

export const getLeagueDailyCrystals = (leagueId) => LEAGUE_DAILY_CRYSTALS[leagueId] || 0;

export const getGloryHallDailyCrystals = (place) => (
  place >= 1 && place <= GLORY_HALL_REWARDED_PLACES ? GLORY_HALL_DAILY_CRYSTALS[place - 1] : 0
);

/**
 * Картинка для модалки — по СУММЕ непрочитанных кристаллов. Границы заданы
 * продуктом; порядок важен, ищем первый подходящий сверху вниз
 */
const CRYSTALS_MODAL_IMAGES = [
  {minCrystals: 500, path: '/img/crystals/crystals_5000.jpg'},
  {minCrystals: 200, path: '/img/crystals/crystals_1000.jpg'},
  {minCrystals: 100, path: '/img/crystals/crystals_500.jpg'},
  {minCrystals: 11, path: '/img/crystals/crystals_300.jpg'},
  {minCrystals: 0, path: '/img/crystals/crystals_100.jpg'},
];

export const getRatingCrystalsImagePath = (totalCrystals) => CRYSTALS_MODAL_IMAGES
  .find((item) => (totalCrystals || 0) >= item.minCrystals).path;
